// extracted by mini-css-extract-plugin
module.exports = {"item":"desktop_type_item-module__item--332xc","selectedItem":"desktop_type_item-module__selectedItem--b3bUX"};